import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { NavigationTab } from 'src/app/shared-module/model/navigation.model';

@Component({
  selector: 'app-navigation-tab',
  templateUrl: './navigation-tab.component.html',
  styleUrls: ['./navigation-tab.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class NavigationTabComponent implements OnInit {
  @Input() navigationTab?: NavigationTab;

  public navigationTabCommand: () => void = () => {};

  ngOnInit(): void {
    this.navigationTabCommand = this.navigationTab?.command ?? (() => {});
  }
}
